import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, docTitle, children }) {
  useEffect(() => {
    document.title = docTitle || `${title} — Asistentes Virtual`;
  }, [title, docTitle]);

  return (
    <div className="min-h-screen bg-white" data-testid="legal-page">
      <div className="mx-auto max-w-3xl px-6 py-16">
        <Link
          to="/"
          data-testid="legal-back"
          className="inline-flex items-center gap-2 text-[14px] text-brand-indigo hover:underline"
        >
          <ArrowLeft size={16} /> Volver a asistentesvirtual.com
        </Link>
        <h1 className="mt-8 text-3xl font-medium tracking-tight text-brand-ink">{title}</h1>
        <div className="mt-3 rounded-[10px] border border-[#F5D989] bg-[#FEF6E7] px-4 py-3 text-[13.5px] text-[#713F12]">
          Plantilla: sustituye los datos entre [corchetes] por los tuyos antes de publicar y,
          si puedes, revísala con un asesor legal.
        </div>
        <article className="legal-content mt-8 text-[15px] leading-[1.75] text-[#5F5E5A]">
          {children}
        </article>
      </div>
    </div>
  );
}
